import axios from 'axios'
import qs from 'qs'

function transformDataToShippingAddress(data) {
  return {
    ...transformDataToAddress(data),
    address_1: data.address,
    city: data.city,
    postcode: data.postal,
    house: data.house,
    country_id: data.country,
    country: data.shippingCountryName,
    zone_id: data.zone_id,
  }
}

function transformDataToPaymentAddress(data) {
  return {
    ...transformDataToAddress(data),
    address_1: data.paymentAddress,
    city: data.paymentCity,
    postcode: data.paymentPostal,
    house: data.paymentHouse,
    country_id: data.paymentCountry,
    country: data.paymentCountryName,
  }
}

function transformDataToAddress(data) {
  return {
    firstname: data.firstname,
    lastname: data.secondname,
    company: data.companyName,
    address_2: '',
    zone: '',
    zone_id: '',
    country: '',
    address_format: '',
    custom_field: '',
    iso_code_2: '',

    address_1: '',
    city: '',
    postcode: '',
    country_id: '',
  }
}

function transformDataToUserInfo(data) {
  return {
    customer_group_id: '',
    firstname: data.firstname,
    lastname: data.secondname,
    email: data.email,
    telephone: data.phone,
    custom_field: '',
  }
}

export function fetchPaymentMethods(data) {
  return axios({
    method: 'post',
    url: '/index.php?route=checkout/checkout/getPaymentMethods',
    data: qs.stringify({
      payment_address: transformDataToPaymentAddress(data),
    })
  })
}

export function fetchShippingMethods(data) {
  return axios({
    method: 'post',
    url: '/index.php?route=checkout/checkout/getShippingMethods',
    data: qs.stringify({
      shipping_address: transformDataToShippingAddress(data),
    })
  })
}

function getGaClientId() {
  try {
    if (window.ga) {
      return window.ga.getAll()[0].get('clientId')
    }
  } catch (e) {
    //
  }
  return null
}

export function saveCheckoutData(data) {
  return axios({
    method: 'post',
    url: '/index.php?route=checkout/confirm/save',
    data: qs.stringify({
      ga_client_id: getGaClientId(),
      payment_address: transformDataToPaymentAddress(data),
      payment_method: {
        title: data.paymentTitle,
        code: data.payment,
      },
      shipping_address: transformDataToShippingAddress(data),
      shipping_method: {
        code: data.shipping,
        title: data.shippingTitle,
        cost: data.shippingCost,
        tax_class_id: data.taxClassId,
      },
      user_info: transformDataToUserInfo(data),
    })
  })
}

export function saveShippingMethod(data) {
  return axios({
    method: 'post',
    url: '/index.php?route=checkout/confirm/saveShippingMethod',
    data: qs.stringify({
      shipping_method: {
        code: data.shipping,
        title: data.shippingTitle,
        cost: data.shippingCost,
        tax_class_id: data.taxClassId,
      },
    })
  })
}

export function saveShippingAddress(data) {
  return axios({
    method: 'post',
    url: '/index.php?route=checkout/confirm/saveShippingAddress',
    data: qs.stringify({
      shipping_address: transformDataToShippingAddress(data),
    })
  })
}

export function loadProducts() {
  return axios.get('/index.php?route=checkout/checkout/products')
}

export function saveUser(data) {
  return axios({
    method: 'post',
    url: '/index.php?route=checkout/confirm/saveUser',
    data: qs.stringify({
      'user_info': transformDataToUserInfo(data)
    })
  })
}

export function saveAdmitadUser(data) {
  return axios({
    method: 'post',
    url: '/index.php?route=checkout/confirm/saveAdmitadUser',
    data: qs.stringify({
      'user_info': transformDataToUserInfo(data)
    })
  })
}

export function fetchZones(countryId) {
  return axios({
    method: 'get',
    url: '/index.php?route=wapi/countries/zones&country_id=' + countryId,
  })
}

export function fetchTotals() {
  return axios({
    method: 'get',
    url: '/index.php?route=checkout/checkout/totals',
  })
}

export function fetchDiscountInfo() {
  return axios({
    method: 'get',
    url: '/index.php?route=checkout/checkout/discountInfo'
  })
}

export async function getProductsCartQuantity() {
  const res = await axios({
    method: 'get',
    url: '/index.php?route=checkout/cart/productsCartQuantity'
  })
  return res.data
}
